const days = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
Object.freeze(days);

export default days;